export function allowEditorPreview(): true | { path: '/', replace: true } {
	// Keep the redirect in an explicit object. A trailing `|| '/'` is valid here,
	// but esbuild's minifier can fold the ternary into `condition || '/'`, which
	// Vue Router interprets as a redirect even when the preview is allowed.
	if (typeof window === 'undefined' || window.self !== window.top) return true
	return { path: '/', replace: true }
}
